import ListUser from "../components/ListUsers.jsx"
import Navbar from "../components/navbar.jsx"


export default function ListUserPage(){
    return(
        <>
        <Navbar />
        <ListUser />
        </>
    )
}